import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { DropdownBodyWrapper, DropdownHeaderWrapper } from './wrappers';
import { RelativeWrapper } from 'wrappers';
import { DropdownCaret, PageCount } from './atoms';
import { Text } from 'atoms';
import React from 'react';
import internalState from './internalState';
import { DownCaretSvg } from 'components/icons';

const dropdownRef = React.createRef();

export const definition = {
  name: 'CountDropdown',
  controller: Controller,
  initialProps: ({ pageSize }) => ({ pageSize }),
  props: internalState,
  elements: [

    {
      wrapper: DropdownHeaderWrapper,
      name: 'Header',
      isButton: true,
      bindings: ({ isOpen }) => ({ isOpen, dropdownRef }),
      elements: [
        {
          component: Text,
          name: 'Text',
          bindings: ({ }) => ({}),
          displayValue: ({ pageSize }) => pageSize === 99999 ? 'All' : pageSize.toString(),
        },
        {
          component: DropdownCaret,
          name: 'Caret',
          displayValue: ({ }) => DownCaretSvg({}),
          bindings: ({ }) => ({})
        },
      ]
    },
    {
      wrapper: DropdownBodyWrapper,
      name: 'Body',
      ref: dropdownRef,
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          component: PageCount,
          name: 'PageSize',
          isListOf: 'countSuggestions',
          bindings: ({ countSuggestion }) => ({ countSuggestion }),
          displayValue: ({ countSuggestion }) => countSuggestion === 99999 ? 'All' : countSuggestion.toString(),
          displayState: ({ countSuggestion, pageSize }) => ({ selected: countSuggestion === pageSize })
        }
      ]
    }
  ]
};

const CountDropdown = wrap(ContainerComponent(definition), RelativeWrapper);

export default CountDropdown;